import "../../Projects/Effet_Mer/Effet_Mer.css";
import Hero from "../../Projects/Effet_Mer/Hero.jsx";
import AboutUs from "../../Projects/Effet_Mer/About.jsx";
import Vitrine from "../../Projects/Effet_Mer/Vitrine.jsx";
import Gif from "../../Projects/Effet_Mer/gif.jsx";
import Palette from "../../Projects/Effet_Mer/Palette.jsx";
import Footer from "../../general/Footer.jsx";

export default function EffetMerPage() {
  return (
    <div className="effet_mer-page">
      <Hero />
      <AboutUs />
      <Vitrine />
      <Palette />
      <Gif />
      <Footer />
    </div>
  );
}
